/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const reviewForecastDaySchema = z.object({
  date: z.string(),
  count: z.number(),
  isOverdue: z.boolean(),
  grammarCount: z.number().optional(),
});

export interface IReviewForecastDay {
  date: string;
  count: number;
  isOverdue: boolean;
  grammarCount?: number;
}

const reviewForecastDataSchema = z.object({
  days: z.array(reviewForecastDaySchema),
  today: z.string(),
  olderOverdueCount: z.number(),
  laterCount: z.number(),
  grammarOlderOverdueCount: z.number().optional(),
  grammarLaterCount: z.number().optional(),
  access: z.object({
    premium: z.boolean(),
    capLimit: z.number(),
    capApplied: z.boolean(),
  }),
});

export interface IReviewForecastData {
  days: IReviewForecastDay[];
  today: string;
  olderOverdueCount: number;
  laterCount: number;
  grammarOlderOverdueCount?: number;
  grammarLaterCount?: number;
  access: { premium: boolean; capLimit: number; capApplied: boolean };
}

export const getProgressForecastV1ResponseSchema = createApiResponseSchema(
  reviewForecastDataSchema,
) as z.ZodSchema<IAPI<IReviewForecastData>>;

export type IGetProgressForecastV1Response = IAPI<IReviewForecastData>;
